import sidebarNavEn from "./locales/en.json";

export const SIDEBAR_NAV_NS = "sidebarNavigation" as const;

export const SidebarNavigationTranslations = {
  en: {
    [SIDEBAR_NAV_NS]: {
      ...sidebarNavEn,
    },
  },
};
